import hotel1 from "../assets/images/hotel_photos/hotel_1.png";
import hotel2 from "../assets/images/hotel_photos/hotel_2.png";
import hotel3 from "../assets/images/hotel_photos/hotel_3.png";
import hotel4 from "../assets/images/hotel_photos/hotel_4.png";
import hotel5 from "../assets/images/hotel_photos/hotel_5.png";
import hotel6 from "../assets/images/hotel_photos/hotel_6.png";
export const hotelPhotos = [
    {
        id: 1,
        src: hotel1
    },
    {
        id: 2,
        src: hotel2
    },
    {
        id: 3,
        src: hotel3
    },
    {
        id: 4,
        src: hotel4
    },
    {
        id: 5,
        src: hotel5
    },
    {
        id: 6,
        src: hotel6
    },
];
